import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {MotionPathPlugin} from "gsap/MotionPathPlugin";

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

document.addEventListener('DOMContentLoaded', () => {
    const blobs = gsap.utils.toArray('.background-blobs-container .blob');
    const section = document.querySelector('.background-blobs-container');

    const colorGreenMid = "#44FF39";
    const colorGreenEdge = "rgba(67, 144, 187, 0.4)";
    const colorBlueMid = "#4390BB";
    const colorBlueEdge = "rgba(0, 24, 69, 0.4)";

    if (blobs) {


        gsap.set(blobs, {
            opacity: 0,
            x: () => section.offsetWidth * 1.5,
            y: () => -section.offsetHeight * 0.5,
        });

        let mainTl = gsap.timeline({
            scrollTrigger: {
                trigger: ".background-blobs-container",
                start: "top top",
                end: "bottom bottom",
                scrub: 1,
                markers: false,
                onUpdate: (self) => {
                    if (self.progress > 0.95 && self.getVelocity() === 0) {
                        floatingTl.play();
                    } else {
                        floatingTl.pause();
                    }
                },
                onLeave: () => {
                    floatingTl.play();
                },
                onEnterBack: () => {
                    if (mainTl.progress() < 0.95) {
                        floatingTl.pause();
                    }
                },
                onLeaveBack: () => {
                    floatingTl.pause();
                },
            }
        });

        mainTl.to(blobs, {
            opacity: 0.8,
            x: (i, target) => {
                return gsap.utils.random(section.offsetWidth * 0.5, section.offsetWidth * 0.9) - target.offsetLeft;
            },
            y: (i, target) => {
                return gsap.utils.random(section.offsetHeight * 0.1, section.offsetHeight * 0.4) - target.offsetTop;
            },
            duration: 0.8,
            stagger: 0.03,
            ease: "power3.out"
        }, 0);

        mainTl.to(blobs, {
            x: (i, target) => {
                return gsap.utils.random(section.offsetWidth * 0.2, section.offsetWidth * 0.8) - target.offsetLeft;
            },
            y: (i, target) => {
                return gsap.utils.random(section.offsetHeight * 0.2, section.offsetHeight * 0.8) - target.offsetTop;
            },
            duration: 1.5,
            ease: "power2.inOut"
        }, 0.8);

        mainTl.to(blobs.slice(0, 4), {
            "--color-blob-mid": colorGreenMid,
            "--color-blob-edge": colorGreenEdge,
            duration: 0.7,
            ease: "power1.out"
        }, 1.2);

        mainTl.to(blobs.slice(4), {
            "--color-blob-mid": colorBlueMid,
            "--color-blob-edge": colorBlueEdge,
            duration: 0.7,
            ease: "power1.out"
        }, 1.4);

        const finalConvergeAndFadeStart = 3.0;

        // Étape de convergence et disparition au centre-bas droite
        mainTl.to(blobs, {
            // Converge vers le côté droit de la section, avec une légère dispersion
            x: (i, target) => (section.offsetWidth * 0.8) - (target.offsetWidth / 2) + gsap.utils.random(-30, 30),
            // Converge vers le bas de la section, légèrement au-dessus du bord, avec dispersion
            y: (i, target) => section.offsetHeight - (target.offsetHeight / 2) - 100 + gsap.utils.random(-30, 30),
            "--color-blob-mid": colorGreenMid,
            "--color-blob-edge": colorGreenEdge,
            filter: 'brightness(.9) blur(100px)',
            opacity: 0,
            scale: 0.2,
            duration: 1.5,
            stagger: {
                amount: 0.1,
                from: "center"
            },
            ease: "power2.in"
        }, finalConvergeAndFadeStart);

        let floatingTl = gsap.timeline({repeat: -1, yoyo: true, paused: true});

        blobs.forEach(blob => {
            floatingTl.to(blob, {
                x: `+=${gsap.utils.random(-10, 10)}`,
                y: `+=${gsap.utils.random(-10, 10)}`,
                scale: `+=${gsap.utils.random(-0.05, 0.05)}`,
                filter: `brightness(.9) blur(${gsap.utils.random(40, 60)}px)`,
                opacity: `+=${gsap.utils.random(-0.05, 0.05)}`,
                duration: gsap.utils.random(3, 5),
                ease: "sine.inOut"
            }, "<");
        });
    }

    // -----------------------

    // Sélecteurs
    const mainContainer = document.querySelector(".container.bg-light.rounded-5");
    const calendarImage = document.querySelector(".container.bg-light.rounded-5 #book-meeting img");
    const titleElement = document.querySelector(".container.bg-light.rounded-5 .content-area .text-uppercase.text-primary.fw-semibold");
    const textBlock = document.querySelector(".container.bg-light.rounded-5 .content-area .mb-");
    const bookMeetingBtn = document.querySelector(".container.bg-light.rounded-5 a.btn.btn-primary");
    const arrow = document.querySelector(".container.bg-light.rounded-5 a.btn.btn-primary .pdw-icon-arrow-diagonal");

    let tl = gsap.timeline({
        defaults: {ease: "power2.out"}
    });

    // Définir l'état initial des éléments avant l'animation
    // Ces 'set' sont importants pour éviter le "flash" de contenu non animé
    // et pour s'assurer que l'animation commence à partir du bon point.
    if (mainContainer) {
        gsap.set(mainContainer, {autoAlpha: 0, y: 20});
    }
    if (calendarImage) {
        gsap.set(calendarImage, {y: 50, autoAlpha: 0});
    }
    if (titleElement) {
        gsap.set(titleElement, {y: 20, autoAlpha: 0});
    }
    if (textBlock) {
        gsap.set(textBlock, {y: 20, autoAlpha: 0});
    }
    if (bookMeetingBtn) {
        gsap.set(bookMeetingBtn, {y: 20, autoAlpha: 0});
    }

    // Ajout des tweens à la timeline
    if (mainContainer) {
        tl.to(mainContainer, {autoAlpha: 1, y: 0, duration: 0.8});
    }
    if (calendarImage) {
        tl.to(calendarImage, {y: 0, autoAlpha: 1, duration: 1}, "<0.2"); // Le "<0.2" signifie 0.2s après le début du tween précédent
    }
    if (titleElement) {
        tl.to(titleElement, {y: 0, autoAlpha: 1, duration: 0.8}, "<0.3");
    }
    if (textBlock) {
        tl.to(textBlock, {y: 0, autoAlpha: 1, duration: 0.7}, "<0.2");
    }
    if (bookMeetingBtn) {
        tl.to(bookMeetingBtn, {y: 0, autoAlpha: 1, duration: 0.6}, "<0.3");
    }

    // Configuration de ScrollTrigger pour la timeline
    if (mainContainer) { // Assurez-vous que le trigger existe
        ScrollTrigger.create({
            trigger: mainContainer, // L'élément qui déclenche le ScrollTrigger
            start: "top center", // Quand le haut du trigger atteint le centre du viewport
            end: "bottom center", // Quand le bas du trigger atteint le centre du viewport (ajustez si besoin)
            scrub: 1, // Lie la progression du scroll à la timeline. '1' pour 1 seconde de "lag"
            markers: false,
            // Si vous voulez une liaison directe sans lag, utilisez 'true'
            animation: tl, // La timeline à contrôler
            toggleActions: "play reverse play reverse", // Définit le comportement: onEnter, onLeave, onEnterBack, onLeaveBack.
            // play = joue en avant, reverse = joue en arrière
            // markers: true, // Pour le débogage, à retirer en production
            // On peut ajouter un 'id' pour identifier facilement les markers
            // id: "main-section-animation"
        });
    }

    // Animation de la flèche du bouton au survol (reste la même)
    if (bookMeetingBtn && arrow) {
        bookMeetingBtn.addEventListener('mouseenter', () => {
            gsap.to(arrow, {x: 5, duration: 0.3, ease: "power1.out"});
        });

        bookMeetingBtn.addEventListener('mouseleave', () => {
            gsap.to(arrow, {x: 0, duration: 0.3, ease: "power1.out"});
        });
    }
    //---------------------------------------

    const tooltip = document.querySelector('.tooltip');
    const tooltipImg = document.querySelector('.tooltip-img');

    if (tooltip) {


        gsap.fromTo(tooltip,
            {opacity: 0, y: 20},
            {opacity: 1, y: 0, duration: 1, ease: "power2.out"}
        );

        ScrollTrigger.create({
            trigger: '#members',
            pin: tooltip,
            start: 'top 30%',
            end: 'bottom 60%',
            pinSpacing: false,
            //markers: true
        });

        const members = document.querySelectorAll('.member');

        members.forEach((member, index) => {
            ScrollTrigger.create({
                trigger: member,
                start: 'top center',
                end: 'bottom center',
                onEnter: () => {
                    gsap.set(tooltipImg, {attr: {src: memberImages[index]}});
                },
                onEnterBack: () => {
                    gsap.set(tooltipImg, {attr: {src: memberImages[index]}});
                }
            });
        });

        members.forEach((member) => {
            gsap.to(member, {
                yPercent: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: member,
                    scrub: true,
                    start: 'top bottom',
                    end: 'bottom top',
                }
            });
        });
    }

    const centerImage = document.querySelector('.cycle-center-image');
    const iconWrappers = document.querySelectorAll('.cycle-icon-wrapper');
    const animatedTexts = document.querySelectorAll('.animated-text');


    const rotationDuration = 25;


    gsap.to(centerImage, {
        rotation: -360,
        duration: rotationDuration,
        ease: "power1.inOut",
        repeat: -1,
        overwrite: "auto"
    });

    const textTl = gsap.timeline({
        delay: 0.8,

    });

    animatedTexts.forEach((textSpan, index) => {
        textTl.fromTo(textSpan,
            {opacity: 0, y: 20},
            {opacity: 1, y: 0, duration: 0.8, ease: "power2.out"}
        );
    });
});